/*
 *操作提示
 */
export const delTip = function(vm, info, title) {
	return new Promise((resolve, reject) => {
		vm.$confirm(info, title, {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			resolve(0);
		}).catch(() => {
			vm.$message({
				type: 'info',
				message: '已取消操作'
			});
		});
	});
}

/**
 * 人民币大写转换
 */
export const numToRMB = function(num) {
	let unit = "万仟佰拾亿仟佰拾万仟佰拾元角分",
		str = ""
	num = String(Math.round(num * Math.pow(10, 2)))
	unit = unit.substr(unit.length - num.length)
	for (let i = 0; i < num.length; i++) {
		str += "零壹贰叁肆伍陆柒捌玖".charAt(num.charAt(i)) + unit.charAt(i);
	}
	return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g,
		"$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整")
}